import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/shared/components'
import { CourierDetailsPage } from '@/pages/couriers/CourierDetailsPage'

export const Route = createFileRoute('/couriers/$userId')({
  component: () => (
    <RequirePermission section="couriers" action="view_card">
      <CourierDetailsPage />
    </RequirePermission>
  ),
})
